import React from "react";
import ReactDOM from "react-dom";

import "aos/dist/aos.css";
import "antd/dist/antd.css";
import "./assets/theme/font-awesome/css/all.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/theme/css/style.css";
import "./assets/theme/css/style-mob.css";
import "./assets/theme/custom.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { themeColor } from "./utils";

document.documentElement.style.setProperty("--themeColor", themeColor);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
